import './App.css';
import 'antd/dist/reset.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormMetaJunior from './forms/FormMetaJunior';
import FormGoogleJunior from './forms/FormGoogleJunior';
import FormGoogleSenior from './forms/FormGoogleSenior';
import FormOrganicJunior from './forms/FormOrganicJunior';
import FormOrganicSenior from './forms/FormOrganicSenior';
import FormYoutubeJunior from './forms/FormYoutubeJunior';
import FormYoutubeSenior from './forms/FormYoutubeSenior';
import FormMetaSenior from './forms/FormMetaSenior';


function App() {
  return (
    <Router>
     
      <Routes>
        <Route path="/form-google-junior" element={<FormGoogleJunior/>} />
        <Route path="/form-google-senior" element={<FormGoogleSenior/>} />
        <Route path="/form-meta-junior" element={<FormMetaJunior/>} />
        <Route path="/form-meta-senior" element={<FormMetaSenior/>} />
        <Route path="/form-organic-junior" element={<FormOrganicJunior/>} />
        <Route path="/form-organic-senior" element={<FormOrganicSenior/>} />
        <Route path="/form-youtube-junior" element={<FormYoutubeJunior/>} />
        <Route path="/form-youtube-senior" element={<FormYoutubeSenior/>} />

        
      </Routes>
    </Router>
  );
}

export default App;

